import React from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { CalendarOutlined } from '@ant-design/icons';
import { CollapseBlock } from '../../index.jsx';
import WorkshopsTable from '../Workshops/FoWorkshopsTable/WorkshopsTable.jsx';
import { FoBasicInformation } from '../FoBasicInformation.jsx';
import { useFoEventBasicInformation } from '../../../../hooks/useFoEventBasicInformation.jsx';
import EventDatesTable from '../Dates/EventDatesTable.jsx';
import useUserHasRole from '../../../../hooks/useUserHasRoles.jsx';
import { ROLE_FRI_OPEN_PARTICIPANT } from '../../../../utils/constants/roles.js';
import { routes } from '../../../../utils/helpers/ApiClient.jsx';
import { IconButton } from '../../controls/Controls.jsx';

const EventsDetail = ({
  event,
  workshops,
  eventDates,
  onDetailClick,
  onRowClick,
  onEventDateRowClick,
}) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const user = useSelector((state) => state.auth?.user);
  const isFriOpenParticipant = useUserHasRole(ROLE_FRI_OPEN_PARTICIPANT);
  const canOpenMyDates = Boolean(user) && isFriOpenParticipant;

  const basicInformation = useFoEventBasicInformation(event);

  const eventDatesTitle = (
    <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
      <span>{t('Termíny v rámci akcie')}</span>
      {canOpenMyDates ? (
        <div>
          <IconButton
            icon={<CalendarOutlined />}
            tooltip={t('Moje prihlásené termíny')}
            onClick={(event) => {
              event.stopPropagation();
              navigate(routes.cmsFoMyDatesList);
            }}
          />
        </div>
      ) : null}
    </div>
  );

  return (
    <>
      <div style={{ margin: '10px' }}>
        <div className="detail-collapse">
          <CollapseBlock collapsible title={t('Základné informácie o akcii')}>
            <FoBasicInformation dataToRender={basicInformation} />
          </CollapseBlock>
        </div>
      </div>
      {eventDates ? (
        <CollapseBlock collapsible title={eventDatesTitle}>
          <EventDatesTable dates={eventDates} onRowClick={onEventDateRowClick} />
        </CollapseBlock>
      ) : null}
      {workshops ? (
        <CollapseBlock collapsible title={t('Semináre v rámci akcie')}>
          <WorkshopsTable
            workshops={workshops}
            onDetailClick={onDetailClick}
            onRowClick={onRowClick}
          />
        </CollapseBlock>
      ) : null}
    </>
  );
};

EventsDetail.propTypes = {
  event: PropTypes.object.isRequired,
  workshops: PropTypes.array,
  eventDates: PropTypes.array,
  onDetailClick: PropTypes.func,
  onRowClick: PropTypes.func,
  onEventDateRowClick: PropTypes.func,
};

export default EventsDetail;
